/** Tamanho da fonte dos documentos clínicos (receituário, atestado, laudos, etc.). */

export const DEFAULT_DOCUMENT_PRINT_FONT_SIZE_PERCENT = 100;

export const DOCUMENT_PRINT_FONT_SIZE_MIN = 85;
export const DOCUMENT_PRINT_FONT_SIZE_MAX = 130;

export const DOCUMENT_PRINT_FONT_SIZE_PRESETS: Array<{ value: number; label: string }> = [
  { value: 90, label: 'Pequeno (90%)' },
  { value: 100, label: 'Padrão (100%)' },
  { value: 110, label: 'Médio (110%)' },
  { value: 120, label: 'Grande (120%)' },
];

export function normalizeDocumentPrintFontSizePercent(raw: unknown): number {
  if (raw === null || raw === undefined || raw === '') return DEFAULT_DOCUMENT_PRINT_FONT_SIZE_PERCENT;
  const n = Number(raw);
  if (!Number.isFinite(n)) return DEFAULT_DOCUMENT_PRINT_FONT_SIZE_PERCENT;
  return Math.round(Math.max(DOCUMENT_PRINT_FONT_SIZE_MIN, Math.min(DOCUMENT_PRINT_FONT_SIZE_MAX, n)));
}

export function documentPrintFontScale(raw: unknown): number {
  return normalizeDocumentPrintFontSizePercent(raw) / 100;
}

/** Escala `font-size: Npx` no CSS de impressão conforme `--doc-fs-scale` no body. */
export function scaleDocumentPrintFontSizes(css: string): string {
  return css.replace(/font-size:\s*([\d.]+)px/g, 'font-size: calc($1px * var(--doc-fs-scale, 1))');
}

/** Estilos inline em HTML de documento (ex.: observações do receituário). */
export function inlineDocumentFontSize(px: number): string {
  return `calc(${px}px * var(--doc-fs-scale, 1))`;
}
